import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { paymentCallback, paymenttransfer } from "../../Services/api-service";
import { CircularProgress } from "@mui/material";
import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import { t } from "i18next";

function PaymentProcess({objectDto, setObjectDto}) {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [timeLeft, setTimeLeft] = useState(0);
  const navigation = useNavigate();
  const [message, setMessage] = useState("");
  const [linkExpired, setLinkExpired] = useState(false);
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const getQueryParam = (param) => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(param);
  };
  const handleCancelClick = () => {
    setIsDialogVisible(true);
  };

  const handleCloseDialog = () => {
    setIsDialogVisible(false);
  };

  const handleConfirmCancel = () => {
    navigation("/");
    setObjectDto(null);
    setIsDialogVisible(false);
  };
  const handlePayment = () => {
    paymenttransfer({...objectDto, repayment: 1});
  }
  useEffect(() => {
      if (timeLeft === 0 && linkExpired) {
        return navigation("/");
      }
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer);
    }, [timeLeft]);
  useEffect(() => {
    const queryData = getQueryParam("data");
    if (queryData) {
      paymentCallback(queryData, setObjectDto, setIsLoading, setMessage).then((data)=>{
        if(data === true) return navigation("/");
        if(data === null) {
          setTimeLeft(5);
          setLinkExpired(true);
          return;
        }
        return;
      }).catch((error)=>{
        setIsLoading(false);
      }).finally(()=>{
        setIsLoading(false);
      });
    }
  }, []);

  return (
    <section className="process content-home">
      {
        isLoading ? 
         <div className="circular-progress-main">
                                <CircularProgress variant="indeterminate" className="progress-circle" size={100} thickness={4} />
                            </div>
                            :
                            !linkExpired ?
        <div style={{textAlign: "center", height:"100%", alignContent: "center"}}>
          <h1 className="home-title-product">{message}</h1>
          <div className="wrap-list-button" style={{alignItems: "baseline"}}>
            <CustomButtonColor title={"Thanh toán lại"} color={"white"} borderRadius={"5px"} bgColor={"#c59812"} onClick={handlePayment} />
            <CustomButtonColor title={"Hủy thanh toán"} color={"white"} borderRadius={"5px"} bgColor={"#c59812"} onClick={handleCancelClick}/>
          </div>
        </div>
        : 
        <div style={{textAlign: "center", height:"100%", alignContent: "center"}}>
          <h1 className="home-title-product">Bạn sẽ được tự động trở về <a href="/" style={{ color: "blue" }}>trang chủ</a> trong vòng {timeLeft} giây nữa</h1>
        </div>
      }
       {isDialogVisible && (
        <>
          <div className="otp-dialog-overlay" onClick={handleCloseDialog}>
          <div className="otp-dialog">
            <h2 className="desc-otp" style={{textAlign: "center"}}>Bạn có muốn hủy thanh toán không?</h2>
            <div className="wrap-list-button" style={{alignItems: "baseline"}}>
              <CustomButtonColor title={t("yes")} color={"white"} borderRadius={"5px"} bgColor={"#c59812"} onClick={handleConfirmCancel} />
              <CustomButtonColor title={t("no")} color={"white"} borderRadius={"5px"} bgColor={"#c59812"} onClick={handleCloseDialog}/>
            </div>
            
          </div>
          </div>
        </>
      )}

      <style jsx>{`
        .dialog {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          padding: 20px;
          background-color: white;
          border: 1px solid #ccc;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          z-index: 9999;
        }

        .overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1040; 
        }

        button {
          margin: 5px;
        }
      `}</style>
    </section>
  );
}

export default PaymentProcess;
